var render = function (_h,_vm) {var _c=_vm._c;return _c('b',[_vm._v(_vm._s(_vm.props.value.value))])}
var staticRenderFns = []

export { render, staticRenderFns }